<template>
    <div  class="register">
        <div v-loading='loading'>
            <el-row>
                <el-card class="box-card" shadow="never">
                    <div slot="header" class="clearfix">
                        <i class="el-icon-user" style="margin-right:5px"></i><span>下单人</span>
                        <el-button v-if="haveEl" type="text" style="float: right; padding: 3px 0" icon="el-icon-sort" @click="cutElderly">切换</el-button>
                        <!-- <el-button type="text" style="float: right; padding: 3px 0" icon="el-icon-sort" @click="dial1">拨号</el-button> -->
                    </div>
                    <el-col :span="24">
                        <el-form :model="searchElForm" :rules="searchElRules" inline ref="searchElForm" v-if="!haveEl">
                            <el-form-item prop="name">
                                <el-input  placeholder="请输入姓名" v-model.trim="searchElForm.name" clearable></el-input>
                            </el-form-item>
                            <el-form-item prop="phone">
                                <el-input  placeholder="请输入手机号" v-model.trim="searchElForm.phone" maxlength="11" clearable></el-input>
                            </el-form-item>
                            <el-button  type="primary" icon="el-icon-search" @click="getElderly">查询</el-button>
                            <el-button  type="success" icon="el-icon-circle-plus-outline" @click="elderlyRegister">注册</el-button>
                        </el-form>
                        <el-table
                            :data="elderlyInfo"
                            style="width: 100%" border stripe max-height='450'>
                            <el-table-column label="姓名" prop="userName" width="100"></el-table-column>
                            <el-table-column label="手机号" prop="userPhone"></el-table-column>
                            <el-table-column prop="createTime" :formatter="getTime" label="注册时间" ></el-table-column>
                            <el-table-column prop="userStatus" :formatter="userStatus" label="状态" ></el-table-column>
                        </el-table>
                    </el-col>
                </el-card>
                <el-card class="box-card" shadow="never">
                    <div slot="header" class="clearfix">
                        <i class="el-icon-shopping-bag-1" style="margin-right:5px"></i><span>关联商品</span>
                        <el-button  type="text" style="float: right; padding: 3px 0" icon="el-icon-circle-plus-outline" @click="getGoods">添加商品</el-button>
                    </div>
                    <el-col :span="24">
                        <el-table
                            :data="goodsData"
                            style="width: 100%" border stripe max-height='450'>
                            <el-table-column prop="name" label="标题" min-width="130" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="nameMore" label="副标题" min-width="200" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="goodsPriceDTOList[0].price" label="单价（元）" width="100"></el-table-column>
                            <el-table-column
                                min-width="140"
                                prop="number"
                                label="数量">
                                <template slot-scope="item">
                                    <el-input-number size="small" :precision='0' :min="0" v-model.trim="item.row.number"></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column
                            min-width="200"
                                prop="planTime"
                                label="预约时间">
                                <template slot-scope="item">
                                    <el-date-picker
                                        v-if="item.row.planTime"
                                        v-model="item.row.planTime"
                                        type="datetime"
                                        :clearable="false"
                                        placeholder="请选择预约时间"
                                        :default-value="new Date()"
                                        :picker-options="pickerOptions0"
                                        value-format="yyyy-MM-dd HH:mm:00"
                                        style="width:100%">
                                    </el-date-picker>
                                    <span v-else style="color:#909399">普通商品无预约时间</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" fixed="right" width="100">
                                <template slot-scope="scope">
                                    <el-button type="danger" size="small" @click.native.prevent="handleDelete(scope.$index, goodsData)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-card>
                <el-card class="box-card" shadow="never" :body-style="cardBodyStyle">
                    <div slot="header" class="clearfix">
                        <i class="el-icon-position" style="margin-right:5px"></i><span>收货地址</span>
                    </div>
                    <el-table
                        :data="addressInfo"
                        style="width: 100%;" border stripe max-height='450' v-if="addressInfo.length>0">
                        <el-table-column prop="receiveName" label="名称" width="150"></el-table-column>
                        <el-table-column prop="receivePhone" label="手机号"></el-table-column>
                        <el-table-column prop="areaNamePath" label="地区"></el-table-column>
                        <el-table-column prop="receiveAddress" width="200" label="详细地址"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button type="primary" size="mini" @click="showAddress(scope.$index, scope.row)">更换</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-button type="primary" v-if="addressInfo.length==0" style="width:300px;margin:40px 20px;" @click="showAddress">选择地址</el-button>
                </el-card>
            </el-row>

        </div>
        <div class="felxBot" v-show="felxBotShow">
            <el-button type="success" style="width:300px;margin:40px;" @click="confirm">订单提交</el-button>
        </div>
        <el-dialog title="老人列表" :visible.sync="elderlyTableShow" :modal-append-to-body='false' width="1000px" :close-on-click-modal='false'>
            <el-table ref="elderlyTable" :data="elderlyTable" border height="500px">
                <el-table-column label="姓名" prop="userName" width="100"></el-table-column>
                <el-table-column label="手机号" prop="userPhone"></el-table-column>
                <el-table-column prop="createTime" :formatter="getTime" label="注册时间" ></el-table-column>
                <el-table-column prop="userStatus" :formatter="userStatus" label="状态" ></el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click.native.prevent="elderlyAdd(scope.row)">选定</el-button>
                        <el-button type="success" size="small" icon="el-icon-phone" @click.native.prevent="dial(scope.row)">拨号</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog
            title="老人注册"
            :visible.sync="elderlyDialog" :before-close="handleClose" top="30vh" width="700px">
            <el-row :gutter="30">
                <el-form :model="addElderlyForm" :rules="elderlyRules" ref="addElderlyForm">
                    <el-col :span="12">
                        <el-form-item label="姓名" required prop="name">
                            <el-input v-model="addElderlyForm.name" placeholder="请输入姓名" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号" required prop="phone">
                            <el-input v-model="addElderlyForm.phone" maxlength="11" placeholder="请输入手机号码" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="elderlyDialog = false">取 消</el-button>
                <el-button type="primary" @click="confirmAddEl">确 定</el-button>
            </span>
        </el-dialog>
        <!-- <CartEdit ref="myCartEdit" v-show="showModalCartEdit" v-on:closeCartEdit="closeCartEdit" v-on:getGoods="getGoods"></CartEdit> -->
        <Address ref="myAddress" v-show="showModalAddress" v-bind:areaValue="areaValue" v-on:closeAddress="closeAddress" v-on:setAddress="setAddress"></Address>
        <GetGoods ref="myGetGoods" v-show="showModalGetGoods" v-on:closeGetGoods="closeGetGoods" v-bind:goodsClassGovValue="goodsClassGovValue" v-on:selectionChange="selectionChange"></GetGoods>
    </div>
</template>

<script>
    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getUrlParams} from "@/utils/auth";

    import Address from "./Address"
    import GetGoods from "./GetGood"

    export default {
        name: 'Cart',
        data() {
            return {
                goodsTableShow:false,
                elderlyDialog:false,
                elderlyTableShow:false,
                showModalGetGoods:false,
                showModalAddress:false,
                loading: false,
                haveEl:false,
                cartInfo:[],
                elderlyTable:[],
                goodsTable:[],
                cardBodyStyle:{'text-align':'center','margin-bottom':'80px'},
                addressInfo:[],
                imgUrl:this.$imgUrl,
                elderly:'',
                userAddressCode:'',
                totalItems:0,
                elderlyCode:'',
                searchElForm:{
                    name:'',
                    phone:'',
                },
                elderlyInfo:[],
                searchElRules:{
                    phone:[
                        { required: false, pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' },
                    ]
                },
                goodsSelection:[],
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                goodsData:[],
                callData:{},
                seatsData:'',
                felxBotShow:false,
                addElderlyForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode: '',
                    name:'',
                    phone:'',
                    serviceDemand: []
                },
                elderlyRules:{
                    phone:[
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        {
                            pattern: /^1[3456789]\d{9}$/,
                            message: '请输入正确的手机号'
                        },
                    ],
                    name:[
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                    ]
                },
                areaValue:[],
            }
        },
        components:{
            Address,
            GetGoods
        },
        created(){
            this.init();
            this.getAreaList();
        },
        watch:{
            $route(){
                var type= getUrlParams();
                if(this.callData.mobile!=type.mobile){
                    this.init()
                }
            },
            goodsData(){
                if(this.goodsData.length>0&&this.userAddressCode){
                    this.felxBotShow=true
                }
            },
            userAddressCode(){
                if(this.goodsData.length>0&&this.userAddressCode){
                    this.felxBotShow=true
                }
            }
        },
        methods: {
            init(){
                this.callData= getUrlParams();
                this.addressInfo=[]
                this.goodsSelection=[]
                this.goodsData=[]
                this.haveEl=false
                this.felxBotShow=false
                this.userAddressCode=""
                if(this.callData.mobile){
                    this.addElderlyForm.phone=this.callData.mobile.slice(4,15)
                    this.getElderlyByPhone(this.addElderlyForm.phone)
                }
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Seats/PageByPhone",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        phone: this.callData.agentMobile.slice(4,15),
                    }
                }).then(
                    (response) => {
                        if (response.data.error === 0) {
                            this.seatsData=response.data.data
                            this.getGoodsClass()
                        }else if(response.data.error === 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )

            },
            getAreaList(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Area/ListAll",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            var data=JSON.stringify(response.data.data);
                            data=JSON.parse(data.replace(/"listAreaDTO":\[\],/g,''))
                            this.areaValue = data
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
            getElderlyByPhone(phone){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Elderly/GetElderlyByPhone",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        phone: phone
                    }
                }).then(
                    (response) => {
                        if (response.data.error === 0) {
                            var data=response.data.data
                            if(data){
                                this.elderlyInfo=[data]
                                this.elderlyCode=data.elderlyCode
                                this.haveEl=true
                            }
                        }else if(response.data.error === 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
            cutElderly(){
                this.haveEl=false
            },
            dial(row){
                window.parent.postMessage({
                    source: 'ccc-sdk',
                    payload: {
                        event: 'callOut',
                        message: {
                                phoneNumber: row.userPhone,  // 必传
                                desc: row.userName // 呼出时系统显示字段，选填，没有时显示 phoneNumber
                        }
                    }
                }, '*')
            },
            // dial1(){
            //     window.parent.postMessage({
            //         source: 'ccc-sdk',
            //         payload: {
            //             event: 'callOut',
            //             message: {
            //                     phoneNumber:13625611060,  // 必传
            //                     desc: '曹先生' // 呼出时系统显示字段，选填，没有时显示 phoneNumber
            //             }
            //         }
            //     }, '*')
            // },
            confirmAddEl(){
                this.$refs.addElderlyForm.validate((valid) => {
                    if(valid){
                        this.addElderlyForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                        this.addElderlyForm.staffCode=this.seatsData.staffCode
                        this.$axios({
                            method: 'post',
                            url: this.$shopUrl+"Elderly/Add",
                            data: this.addElderlyForm
                        }).then(
                            (response) => {
                                if (response.data.error == 0) {
                                    this.elderlyDialog=false
                                    var data=response.data.data
                                    this.$confirm('添加成功，是否为此老人下单？', '提示', {
                                        confirmButtonText: '确定',
                                        cancelButtonText: '取消',
                                        type: 'warning'
                                        }).then(() => {
                                            this.elderlyInfo=[data]
                                            this.elderlyCode=data.elderlyCode
                                            this.haveEl=true
                                        }).catch(() => {});
                                }else if(response.data.error == 1){
                                    this.$message.error(response.data.message)
                                }
                            }
                        )
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })
            },
            elderlyRegister(){
                this.elderlyDialog=true
            },
            handleClose(done){
                this.$refs.addElderlyForm.resetFields();
                done();
            },
            getGoodsClass(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"GoodsClassGovernment/List",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: this.seatsData.staffCode,
                    }
                }).then(
                    (response) => {
                        if (response.data.error === 0) {
                            this.goodsClassGovValue = response.data.data;
                        }else if(response.data.error === 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
            closeSelf() {
                this.$emit("closeCart");
            },
            elderlyAdd(row){
                this.elderlyInfo=[row]
                this.elderlyCode=row.elderlyCode
                this.elderlyTableShow=false
            },
            //商品添加回显
            selectionChange(val){
                this.goodsSelection=val
                this.goodsData=this.getGoodsData(val)
            },
            //商品添加回显数据处理
            getGoodsData(val){
                var list=[]
                val.forEach(element => {
                    var element1=null
                    if(this.goodsData.length>0){
                        this.goodsData.forEach(element2 => {
                            if(element2.goodsCode==element.goodsCode){
                                element1={planTime:element2.planTime,number:element2.number}
                            }
                        })
                    }
                    if(!element1){
                        element1={planTime:element.goodsType==2?timefilters(new Date()).slice(0,16)+':00':null,number:1}
                    }
                    Object.assign(element1,element)
                    list.push(element1)
                });
                return list
            },
            //商品添加
            getGoods(){
                this.$refs.myGetGoods.init(this.goodsData,this.seatsData.staffCode)
                this.showModalGetGoods=true
            },
            //商品删除
            handleDelete(index, rows){
                this.$confirm('此操作将删除此商品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    rows.splice(index, 1);
                    this.goodsSelection.splice(index, 1);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            showAddress(){
                if(!this.elderlyCode){
                    this.$message.error('请选择老人')
                    return
                }
                this.$refs.myAddress.init(this.elderlyCode);
                this.closeAddress()
            },
            setAddress(address){
                this.addressInfo=[]
                this.addressInfo.push(address);
                this.userAddressCode=address.userAddressCode
            },
            //提交
            confirm(){
                if(this.goodsData.length==0){
                    this.$message.error('请添加商品')
                    return
                }
                if(!this.userAddressCode){
                    this.$message.error('请选择收货地址')
                    return
                }
                this.loading = true;
                var data={
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    timeStr:timeStr,
                    staffCode:this.seatsData.staffCode,
                    userAddressCode:this.userAddressCode,
                    elderlyCode:this.elderlyCode
                }
                Object.assign(data,this.getSubmitData())
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"AppCare/CallSubmit",
                    data: data
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$message.success('下单成功');
                            this.init();
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
            //提交数据处理
            getSubmitData(){
                var totalPrice=0
                var goodsList=[]
                this.goodsData.forEach(element => {
                    totalPrice+=element.goodsPriceDTOList[0].price*element.number
                    if(element.goodsType==2){
                        goodsList.push(this.getGoodsListData(element))
                    }else{
                        var goodsInfo=null
                        goodsList.forEach(element1=>{
                            if(element1.goodsType==1&&element.businessCode==element1.businessCode){
                                element1.price+=element.goodsPriceDTOList[0].price*element.number
                                goodsInfo={
                                    goodsCode:element.goodsCode,
                                    number:element.number,
                                    planTime:element.planTime,
                                    goodsPriceCode:element.goodsPriceDTOList[0].goodsPriceCode,
                                }
                                element1.goodsInfoList.push(goodsInfo)
                            }
                        })
                        if(!goodsInfo){
                            goodsList.push(this.getGoodsListData(element))
                        }
                    }
                });
                return {totalPrice:totalPrice,goodsList:goodsList}
            },
            getGoodsListData(element){
                var data={
                        businessCode:element.businessCode,
                        price:element.goodsPriceDTOList[0].price*element.number,
                        goodsType:element.goodsType,
                        goodsInfoList:[{
                            goodsCode:element.goodsCode,
                            number:element.number,
                            planTime:element.planTime,
                            goodsPriceCode:element.goodsPriceDTOList[0].goodsPriceCode,
                        }]
                    }
                return data
            },
            closeGetGoods:function(){
                this.showModalGetGoods = !this.showModalGetGoods;
            },
            closeAddress:function(){
                this.showModalAddress = !this.showModalAddress;
            },
            getTime(row,index,column){
                return timefilters(column)
            },
            userStatus(row) {
                if (row.userStatus == 1) {
                    return "正常";
                }
                if (row.userStatus == 2) {
                    return "禁用";
                }
                return "其它";
            },
            getElderly(){
                this.$refs.searchElForm.validate((valid) => {
                    if(valid){
                        if(!this.searchElForm.name&&!this.searchElForm.phone){
                            this.$message.error('请输入筛选项')
                            return
                        }
                        var data={
                            timeStr:timeStr,
                            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                            staffCode: this.seatsData.staffCode,
                            status:-1,
                            pageIndex:1,
                            pageSize:30
                        }
                        Object.assign(data,this.searchElForm)
                        this.loading=true
                        this.$axios({
                            method: 'post',
                            url: this.$shopUrl+"Elderly/PageForGovernmentCode",
                            data:data
                        }).then(
                            (response) => {
                                this.loading=false
                                if (response.data.error == 0) {
                                    this.elderlyTable=response.data.data.list;
                                    this.elderlyTableShow=true
                                }else if(response.data.error == 1){
                                    this.$message.error(response.data.message)
                                }
                            }
                        )
                    }else {
                        return false;
                    }
                })

            },
        }
    }

</script>

<style lang="scss" scoped>

.register{
    background-color: #fff;
    height: 100%;
    width: 100%;
    margin: 0 auto;
    /* display: flex;
    justify-content: center; */
    .box-card{
        margin-bottom:20px;
        border-bottom: none;
    }
    .felxBot{
        position: fixed;
        text-align: center;
        width: 100%;
        bottom:0;
        z-index: 99;
        background: #fff;

    }
}
.login_icon{
    margin-right: 10px;
    transform: translate(0,3px);

}

.ysr {
    color: rgba(9, 178, 255, 0.8)
}
</style>
